import adSegmentsCtrl from './ad-segments.controller';

import template from './ad-segments.jade';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      segments: '=',
      ad: '=',
      categoryInfo: '=',
      form: '=',
    },
    controller: adSegmentsCtrl,
    controllerAs: 'adSegmentsCtrl',
    replace: true,
    // link function is called after controller
    link(scope) {
      // Код здесь, потому что мы не хотим в контроллере использовать имя adSegmentsCtrl,
      // очень теоретически контроллер может быть использован в другом месте
      scope.attributesBindingsBySegment = {
        'about-building': {
          category: '{{adSegmentsCtrl.ad.category}}',
          'category-info': 'adSegmentsCtrl.categoryInfo',
          ad: 'adSegmentsCtrl.ad',
          form: 'adSegmentsCtrl.form',
        },
        'about-object': {
          category: '{{adSegmentsCtrl.ad.category}}',
          'category-info': 'adSegmentsCtrl.categoryInfo',
          form: 'adSegmentsCtrl.form',
          ad: 'adSegmentsCtrl.ad',
        },
        'ad-placing-terms': {
          'publish-terms': 'adSegmentsCtrl.ad.publishTerms',
          balance: '{{adSegmentsCtrl.getUserBalance()}}',
          'agency-balance': '{{adSegmentsCtrl.getAgencyBalance()}}',
          tariff: '{{adSegmentsCtrl.getUserTariff()}}',
          id: '{{adSegmentsCtrl.ad.id}}',
          status: '{{adSegmentsCtrl.ad.status}}',
          category: '{{adSegmentsCtrl.ad.category}}',
          'is-failed': 'adSegmentsCtrl.termsIsFailed',
          'business-shopping-center-id': 'adSegmentsCtrl.ad.businessShoppingCenter.id',
          'photos-count': '{{adSegmentsCtrl.ad.photos.length}}',
          'new-object-id': 'adSegmentsCtrl.ad.geo.jk.id',
          'new-object-house-id': 'adSegmentsCtrl.ad.geo.jk.house.id',
          'is-sub-agent': '{{adSegmentsCtrl.isSubAgent()}}',
          'sub-agent-money-source': '{{adSegmentsCtrl.getSubAgentMoneySource()}}'
        },
        summary: {},
        'ad-submit-buttons': {
          ad: 'adSegmentsCtrl.ad',
          form: 'adSegmentsCtrl.form',
          'terms-is-failed': 'adSegmentsCtrl.termsIsFailed',
        },
        'ad-submit-jk': {
          ad: 'adSegmentsCtrl.ad',
          form: 'adSegmentsCtrl.form',
        },
        'ad-type': {
          'deal-type': 'adSegmentsCtrl.categoryInfo.dealType',
          'property-type': 'adSegmentsCtrl.categoryInfo.propertyType',
          'rent-duration': 'adSegmentsCtrl.categoryInfo.rentDuration',
          'object-type': 'adSegmentsCtrl.categoryInfo.objectType',
          category: 'adSegmentsCtrl.ad.category',
          ad: 'adSegmentsCtrl.ad',
        },
        address: {
          category: '{{adSegmentsCtrl.ad.category}}',
          'category-info': 'adSegmentsCtrl.categoryInfo',
          ad: 'adSegmentsCtrl.ad',
          form: 'adSegmentsCtrl.form',
        },
        amenities: {
          ad: 'adSegmentsCtrl.ad',
        },
        auth: {},
        'auth-last-step': {},
        'contact-info': {
          form: 'adSegmentsCtrl.form',
          ad: 'adSegmentsCtrl.ad',
          phones: 'adSegmentsCtrl.ad.phones',
        },
        'cadastral-number-segment': {
          form: 'adSegmentsCtrl.form',
          ad: 'adSegmentsCtrl.ad',
        },
        'description-and-photos': {
          'deal-type': 'adSegmentsCtrl.categoryInfo.dealType',
          'property-type': 'adSegmentsCtrl.categoryInfo.propertyType',
          'rent-duration': 'adSegmentsCtrl.categoryInfo.rentDuration',
          'object-type': 'adSegmentsCtrl.categoryInfo.objectType',
          category: 'adSegmentsCtrl.ad.category',
          ad: 'adSegmentsCtrl.ad',
        },
        infrastructure: {
          ad: 'adSegmentsCtrl.ad',
          'set-segment-visible': 'adSegmentsCtrl.setSegmentVisible(segment, value)'
        },
        'infrastructure-and-leisure': {},
        'phone-verify': {},
        'price-and-deal-terms': {
          category: '{{adSegmentsCtrl.ad.category}}',
          'category-info': 'adSegmentsCtrl.categoryInfo',
          ad: 'adSegmentsCtrl.ad',
          form: 'adSegmentsCtrl.form',
        },
        'homeowner': {
          'form': 'adSegmentsCtrl.form',
          'ad': 'adSegmentsCtrl.ad',
        },
        'this-object-on-other-websites': {},
        'short-form-switcher': {},
        'rent-helper': {},
        'new-building-form': {},
        'get-additional-benefits': {
          ad: 'adSegmentsCtrl.ad',
          form: 'adSegmentsCtrl.form',
        },
        'indexing-delay-alert': {},
        'disabled-warning': {},
        'homeowner-warning': {},
        'coworking-workplace-warning': {},
        'coworking-workplace-banner': {},
      };
    },
  };
};
